import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

// const isDebug = process.env.NODE_ENV !== 'production'

export default {
  postApi: (bvModal, params, callbackSuccess) => {
    return AppModel.post(
      'data/csv',
      bvModal,
      params,
      callbackSuccess,
      () => {

      }
    )
  },
  getStore: (key) => {
    return AppModel.getStore('production_sheets', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/CreateDataCSVModel.js